import {ModuleNode} from '@backstage-components/base';
import {VFC} from 'react';
import {SchemaType} from './IntercomDefinition';

export type IntercomProps = SchemaType;

export const IntercomPreviewComponent: VFC<
  ModuleNode<'Intercom', IntercomProps>
> = () => {
  return (
    <p>
      UI for this component is provided by Intercom. Please ensure this
      component is in the root of the page and that there is only one per page.
    </p>
  );
};
